import { render } from "./CreateSingleTrainingButton.vue?vue&type=template&id=a46f785a"
import script from "./CreateSingleTrainingButton.vue?vue&type=script&lang=js"
export * from "./CreateSingleTrainingButton.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/halisclock/releases/44/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__